// DS: TA0.1
import type { FC } from 'react';
import { useSelector } from 'react-redux';
import Sticky from '@wix/da-ds/pkg/Sticky';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { getIsGroupProfile } from '../../../selectors/users';
import UserProfileSubNavDesktop from './variants/UserProfileSubNavDesktopInner';
import GroupProfileSubNavDesktop from './variants/GroupProfileSubNavDesktopInner';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import s from './SubNavBarDesktop.scss';

export interface Props {}

const SubNavBarDesktop: FC<Props> = () => {
  const isGroup = useSelector(getIsGroupProfile);
  const unsticky = useFlag('unsticky_profile_subnav');
  // TODO if we merge unsticky_profile_subnav - remove isSticky prop from SubNavBarDesktopInner
  // and clean up redundant CSS.
  return (
    <div className={s['root']}>
      <ErrorBoundary debugComponent="SubNavBarDesktop">
        {unsticky ? (
          isGroup ? (
            <GroupProfileSubNavDesktop isSticky={false} />
          ) : (
            <UserProfileSubNavDesktop isSticky={false} />
          )
        ) : (
          <Sticky zIndex={parseInt(s['z-index'])} usePortal>
            {isSticky =>
              isGroup ? (
                <GroupProfileSubNavDesktop isSticky={isSticky} />
              ) : (
                <UserProfileSubNavDesktop isSticky={isSticky} />
              )
            }
          </Sticky>
        )}
      </ErrorBoundary>
    </div>
  );
};

export default SubNavBarDesktop;
